import LeafletMap from '../../views/map/LeafletMap.vue';
import GoogleMapsApi from '../GoogleMapsApi';

/**
 * Add to component's mixins and use with the GoogleMapsApi class to add an autocompleting address field.
 */
export const AddressAutocompleteMixin = {
  components:{
    LeafletMap
  },
  data(){
    return {
      GoogleMapsApi,
      fullAddress: '',
      addressCoordinates:{
        lat: null,
        lng: null,
      }
    };
  },
  computed:{
    hasAddressLocation(){
      return this.addressCoordinates && this.addressCoordinates.lat !== null && this.addressCoordinates.lng !== null;
    },
    addressMapPoint(){
      if(!this.hasAddressLocation) return [];
      return [{
        center: [ this.addressCoordinates.lat, this.addressCoordinates.lng, ],
        tooltip: this.fullAddress,
      }]
    },
    mapCenter(){
      if(!this.hasAddressLocation) return [];
      return [ this.addressCoordinates.lat, this.addressCoordinates.lng, ];
    },
  }
};




// WEBPACK FOOTER //
// ./src/utils/mixins/address-auto-complete.mixin.js